// src/components/asset-manager/FilePicker.tsx
import React from 'react';
import AssetManager from './AssetManager';
import { Asset } from './FileExplorer';
import { X } from 'lucide-react';

interface FilePickerProps {
  allowedFileTypes?: string[];
  multiSelect?: boolean;
  onSelect: (selectedAssets: Asset[]) => void;
  onClose: () => void;
}

const FilePicker: React.FC<FilePickerProps> = ({
  allowedFileTypes,
  multiSelect = true,
  onSelect,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-3/4 h-[90vh] rounded-xl relative overflow-hidden">
          <button
            onClick={onClose}
            className="absolute top-2 right-2 z-20 p-2 hover:bg-blue-100 rounded-full transition-colors duration-200"
          >
            <X size={20} className="text-gray-500" />
          </button>
        
        <AssetManager
          isPicker={true}
          allowedFileTypes={allowedFileTypes}
          multiSelect={multiSelect}
          onSelect={(assets) => {
            onSelect(assets);
            onClose();
          }}
        />
      </div>
    </div>
  );
};

export default FilePicker;